module.exports = __webpack_public_path__ + "static/img/div-base-img2.f82dd95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCodePhone/div-base-img2.png
// module id = Izo9
// module chunks = 0